import { render, staticRenderFns } from "./kaibo.vue?vue&type=template&id=f810a392&scoped=true"
import script from "./kaibo.vue?vue&type=script&lang=js"
export * from "./kaibo.vue?vue&type=script&lang=js"
import style0 from "./kaibo.vue?vue&type=style&index=0&id=f810a392&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f810a392",
  null
  
)

export default component.exports